import mixitup from 'mixitup';
import mixitupMultifilter from '../../app/scripts/vendor/mixitup-multifilter';

mixitup.use(mixitupMultifilter);

const Mixitup = {
  container: function () {
    var mixer = mixitup('.collection__list__products', {
      animation: {
        enable: false
      },
      controls: {
        toggleLogic: 'and'
      },
      multifilter: {
        enable: true // enable the multifilter extension for the mixer
      }
    });
  },
  filterUrlUpdate: function () {
    var filterItems = [].slice.call(document.querySelectorAll('.filter-items')),
    url             = window.location.href.split('?')[0],
    clearFilter     = document.querySelector('.product-grid__filter-clear');

    filterItems.map(element => element.addEventListener('click', () => Mixitup.clickToChange(element)));
    filterItems.forEach(item => {
      var filterCategory = item.dataset.toggle,
          filterCategory = filterCategory.replace('.', '');
      
      if(window.location.href.indexOf(filterCategory) > -1) {
        setTimeout(function () { item.click(); }, 0);
      }
    })
    clearFilter.addEventListener('click', () => {
      window.history.pushState(null, null, url);
    });
  },
  clickToChange: function (elem) {
    var filterItem = elem,
    url            = window.location.href,
    filterCategory = elem.dataset.toggle,
    filterCategory = filterCategory.replace('.', '');

    if (filterItem.classList.contains('mixitup-control-active')) {
      var filterQuery = '?filter=' + filterCategory + '',
          url = url.replace(filterQuery, '');
      window.history.pushState(null, null, url);
    } else {
      if (!url.includes(filterCategory)) {
        window.history.pushState(null, null, '' + url + '?filter=' + filterCategory + '');
      }
    }
  },
}

export default Mixitup;